import { Button, Col, DatePicker, Drawer, Flex, Form, Input, Row } from "antd";
import React, { useEffect, useState } from "react";
import dayjs from "dayjs";

const FilterComponent = ({
  openDrawer,
  closeDrawer,
  data,
  handleFilterDetailsChange,
  filterValues,
  screenName,
  resetFilterValues,
}) => {
  const [searchValues, setSearchValues] = useState([]);
  const [drawerValues, setDrawerValues] = useState({});
  const [computedLabels, setComputedLabels] = useState({});

  const excludedKeys = [
    "__v",
    "id",
    "_id",
    "createdAt",
    "updatedAt",
    "companyId",
    "status",
    "allowAudit",
    "branchId",
    "createdAt",
    "departmentId",
    "roleId",
    "personalNumber",
    "permissionLevel",
    "permissionLevels",
    "restricted",
    "committeeTypeId",
    "secretaryId",
    "assistantSecretaryId",
    "createdDate",
    "assistantSecretary",
    "secretaryUser",
    "committeeType",
    "lastPasswordUpdateDate",
    "passwordExpireDate",
    "isUserLock",
    "userId",
    "created_at",
    "updated_at",
    "address",
    "designation",
    "committee",
    // "roleName",
  ];

  const handleSearchFilter = () => {
    handleFilterDetailsChange(searchValues);
    closeDrawer();
  };

  useEffect(() => {
    if (Object.keys(data).length > 0) {
      console.log(data[0], "data[0]");
      setDrawerValues(data[0]);
    }
  }, [data]);
  
  useEffect(() => {
    setSearchValues(filterValues);
  }, [openDrawer]);

  useEffect(() => {
    if (Array.isArray(searchValues) && searchValues.length === 0) {
      resetFilterValues();
    }
  }, [searchValues]);

  const getValueByKey = (keyToFind, data) => {
    const item = data.find((item) => item.key === keyToFind);
    return item ? item.value : null;
  };

  const formatLabel = (str) => {
    return str.replace(/([a-z])([A-Z])/g, "$1 $2");
  };

  const labelList = {
    masterData_branch: [
      { label: "Branch Code", value: "code" },
      { label: "Branch Name", value: "name" },
    ],
    masterData_department: [
      { label: "Department Code", value: "code" },
      { label: "Department Name", value: "name" },
    ],
    masterData_role: [
      { label: "Role Name", value: "name" },
      { label: "Description", value: "description" },
    ],
    masterData_user: [
      { label: "Name", value: "name" },
      { label: "Email", value: "email" },
      { label: "Address", value: "address" },
      { label: "Role", value: "roleName" },
      { label: "Branch Name", value: "branchName" },
      { label: "Department Name", value: "departmentName" },
      { label: "Designation", value: "designation" },
      { label: "Personal Phone", value: "personalNumber" },
    ],
    masterData_committee: [
      { label: "Committee Type Code", value: "code" },
      { label: "Committee Type Name", value: "name" },
      { label: "Description", value: "description" },
    ],
    committee_management: [
      { label: "Committee Name", value: "name" },
      { label: "Committee Type", value: "committeeType" },
      { label: "Committee Code", value: "code" },
      { label: "Secretary", value: "secretaryUser" },
      { label: "Assistant Secretary", value: "assistantSecretary" },
      { label: "Members", value: "members" },
      { label: "Created Date", value: "createdDate" },
    ],
    leaveManagement: [
      { label: "Leave Date", value: "leaveDate" },
      { label: "Leave Type", value: "leaveType" },
      { label: "Signatory Name", value: "signatoryNames" },
      { label: "Comment", value: "comment" },
    ],
  };

  useEffect(() => {
    if (!drawerValues) return;

    const relavantLabels = labelList[screenName] || [];
    const labels = {};

    Object.keys(drawerValues).forEach((key) => {
      const matchedLabel = relavantLabels.find((item) => item.value === key);
      labels[key] = matchedLabel
        ? matchedLabel.label
        : formatLabel(key.charAt(0).toUpperCase() + key.slice(1));
    });

    setComputedLabels(labels);
  }, [drawerValues, screenName]);

  return (
    <div>
      <Drawer
        open={openDrawer}
        onClose={closeDrawer}
        // size='large'
        title="Search Filter"
        footer={[
          <Flex justify="flex-end" align="center" gap="large">
            <Button onClick={closeDrawer}>Cancel</Button>
            <Button type="primary" onClick={handleSearchFilter}>
              Search
            </Button>
          </Flex>,
        ]}
      >
        <Form layout="vertical">
          {drawerValues &&
            Object.keys(drawerValues).map((single, index) => {
              if (
                excludedKeys.includes(single)
                || (screenName === "masterData_committee" && single === "description")
                || (screenName === "committee_management" && single === "description")
                || (screenName === "masterData_user" && single === "departmentName")
                || (screenName === "leaveManagement" && single === "key")
              ) {
                return null
              }
              return (
                <Row gutter={12} key={index}>
                  <Col span={24}>
                    <Form.Item label={computedLabels[single]}>
                      {screenName === "leaveManagement" && single === "leaveDate" ? (
                        <DatePicker
                          style={{ width: '100%' }}
                          placeholder="Select date"
                          value={getValueByKey(single, searchValues) ? dayjs(getValueByKey(single, searchValues)) : null}
                          onChange={(date) => {
                            const dateValue = date ? date.format('YYYY-MM-DD') : '';
                            
                            setSearchValues((prev) => {
                              const index = prev.findIndex(
                                (item) => item.key === single
                              );

                              if (index > -1) {
                                const updateItems = [...prev];
                                if (dateValue === "") {
                                  updateItems.splice(index, 1);
                                } else {
                                  updateItems[index].value = dateValue;
                                }
                                return updateItems;
                              }
                              else {
                                return [
                                  ...prev,
                                  { key: single, value: dateValue },
                                ];
                              }
                            });
                          }}
                          format="YYYY-MM-DD"
                          inputReadOnly={true}
                        />
                      ) : single !== "description" ? (
                        <Input
                          placeholder="Type search value"
                          value={getValueByKey(single, searchValues)}
                          onChange={(e) => {
                            let inputValue = e.target.value;
                            
                            setSearchValues((prev) => {
                              const index = prev.findIndex(
                                (item) => item.key === single
                              );

                              // if (index > -1) {
                              //   const updateItems = [...prev];
                              //   updateItems[index].value = e.target.value;
                              //   return updateItems;
                              // } 

                              if (index > -1) {
                                const updateItems = [...prev];
                                if (inputValue.trim() === "") {
                                  updateItems.splice(index, 1);
                                } else {
                                  updateItems[index].value = inputValue;
                                }
                                return updateItems;
                              }
                              else {
                                return [
                                  ...prev,
                                  { key: single, value: inputValue },
                                ];
                              }
                            });
                          }}
                          autoComplete="new-name"
                        />
                      ) : (
                        <Input.TextArea
                          placeholder="Type search value"
                          autoComplete="new-description"
                          value={getValueByKey(single, searchValues)}
                          onChange={(e) => {
                            setSearchValues((prev) => {
                              const index = prev.findIndex(
                                (item) => item.key === single
                              );

                              // if (index > -1) {
                              //   const updateItems = [...prev];
                              //   updateItems[index].value = e.target.value;
                              //   return updateItems;
                              // } 

                              if (index > -1) {
                                const inputValue = e.target.value;
                                const updateItems = [...prev];
                                if (inputValue.trim() === "") {
                                  updateItems.splice(index, 1);
                                } else {
                                  updateItems[index].value = e.target.value;
                                }
                                return updateItems;
                              }
                              else {
                                return [
                                  ...prev,
                                  { key: single, value: e.target.value },
                                ];
                              }
                            });
                          }}
                        />
                      )}
                    </Form.Item>
                  </Col>
                </Row>
              )
            })
          }
        </Form>
      </Drawer>
    </div>
  );
};

export default FilterComponent;
